import React from 'react';

function StrengthsProfileCtaMF2026({ translations }) {
  const buttonText = translations?.button?.text || '';
  const buttonHref = translations?.button?.href || '';

  if (!translations?.description || !buttonText) {
    return null;
  }

  return (
    <section className="py-10 md:py-14" aria-labelledby="strengths-profile-cta-heading">
      <div className="container mx-auto max-w-5xl px-4 md:px-6">
        <div className="rounded-2xl bg-swiss-300 px-6 py-10 md:px-12 md:py-12 flex flex-col items-center text-center gap-6">
          {translations?.image && (
            <span
              className="w-16 h-16 md:w-[77px] md:h-[107px] flex items-center justify-center shrink-0 [&>svg]:max-w-full [&>svg]:max-h-full [&>svg]:w-auto [&>svg]:h-auto"
              dangerouslySetInnerHTML={{ __html: translations.image }}
            />
          )}
          <h2
            id="strengths-profile-cta-heading"
            className="text-white text-base md:text-lg lg:text-xl font-bold leading-relaxed max-w-3xl"
            dangerouslySetInnerHTML={{ __html: translations.description }}
          />
          <a
            href={buttonHref}
            target="_blank"
            rel="noreferrer noopener"
            className="inline-flex items-center justify-center rounded-full bg-white px-8 py-3 text-base font-bold text-[#2D5F5F] shadow-sm transition hover:bg-white/95 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#2D5F5F]">
            {buttonText}
          </a>
        </div>
      </div>
    </section>
  );
}

export { StrengthsProfileCtaMF2026 };
